import { useEffect, useRef } from "react";
import { getAccessToken } from "@lhd/utility";
import { disconnectSharedCable, getSharedCable } from "@lhd/libs/actionCable";

const CABLE_CLOSE_GRACE_MS = 300;

export const useTokenRotationCableReset = () => {
  const lastTokenRef = useRef<string>(getAccessToken());
  const reconnectTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    const handleTokenChange = (prevToken: string, newToken: string) => {
      lastTokenRef.current = newToken;
      // Case logout
      if (!newToken) {
        disconnectSharedCable();
        return;
      }

      // Case token rotate
      if (prevToken) {
        disconnectSharedCable();
      }

      if (reconnectTimerRef.current) {
        clearTimeout(reconnectTimerRef.current);
      }

      const delay = prevToken ? CABLE_CLOSE_GRACE_MS : 0;
      reconnectTimerRef.current = setTimeout(() => {
        // Check token valid after sleep
        if (getAccessToken() === newToken) {
          getSharedCable();
        }
      }, delay);
    };

    const POLL_INTERVAL_MS = 3000;
    const intervalId = setInterval(() => {
      const currentToken = getAccessToken();
      if (currentToken !== lastTokenRef.current) {
        handleTokenChange(lastTokenRef.current, currentToken);
      }
    }, POLL_INTERVAL_MS);

    return () => {
      clearInterval(intervalId);
      if (reconnectTimerRef.current) {
        clearTimeout(reconnectTimerRef.current);
      }
    };
  }, []);
};
